export interface ConnectionErrorScreenProps {
  message: string;
  onRetry: () => void;
  /** Sprint-006 D5 (F-D4-3, ux-review-sprint-006.md) — how many "Try
   * again" attempts have failed in a row. After the second consecutive
   * failure, a weak-signal-framed line is added so repeated taps with no
   * other change read as "no signal yet," not as a broken app — a real
   * scenario for a rural farm's known dead zones. Optional/defaulted so
   * any older caller keeps working unchanged. */
  consecutiveFailures?: number;
}

export function ConnectionErrorScreen({
  message,
  onRetry,
  consecutiveFailures = 0,
}: ConnectionErrorScreenProps) {
  return (
    <div class="logged-out-screen">
      <span class="app-wordmark">Hayloft</span>
      <h1 class="logged-out-heading">Couldn't connect</h1>
      <p class="logged-out-copy">{message}</p>
      {consecutiveFailures >= 2 ? (
        <p class="logged-out-copy">
          Still can't reach Hayloft — this can happen with a weak signal. It'll work again once
          you're back in range.
        </p>
      ) : null}
      <button type="button" class="primary-btn" onClick={onRetry}>
        Try again
      </button>
    </div>
  );
}
